<template>
  <div style="padding: 0 15px">
    <!-- <Echart id="leftCenter" :options="options" width="100%" height="235px" v-if="pageflag" ref="charts" /> -->
    <dv-scroll-board
      :config="dataVal"
      @click="tapsq"
      :index="false"
      style="width: 100%; height: 235px"
    />
    <!-- <rank :config="dataVal" scroll-wrapper="peopleScrollWrapperOne" scroll-list="peopleScrollListOne" @click="tapsq" style="width: 100%; height: 235px" /> -->
  </div>
</template>

<script>
// import rank from "@/views/rank";
export default {
  components: {
    // rank
	},
  data() {
    return {
      config: {
        data: [
          {
            name: "商圈1",
            value: 55,
          },
          {
            name: "商圈2",
            value: 120,
          },
          {
            name: "商圈3",
            value: 78,
          },
          {
            name: "商圈4",
            value: 66,
          },
          {
            name: "商圈5",
            value: 80,
          },
          {
            name: "商圈6",
            value: 45,
          },
          {
            name: "商圈7",
            value: 29,
          },
        ],
      },
      pageflag: true,
      options: {},
      timer: null,
    };
  },
  props: {
    dataVal: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    dataVal: {
      handler(newData) {
        this.$nextTick(() => {
        //   this.getData();
        });
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    // this.getData();
  },
  beforeDestroy() {
    this.clearData();
  },
  methods: {
    tapsq(e) {
      this.$emit("openShow",{name:"LeftCenter",val: e.rowIndex})
      console.log(e.rowIndex,"生活圈列表")
    },
    getData() {
      ////////////////////////////////
    },
    clearData() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
  },
};
</script>
